import * as forge from 'node-forge';

export const OauthTools = {
    generateRandomCodeVerifier: () => {
        // Size doit être entre 43 et 128
        const codeSize = 43 + Math.floor(Math.random() * 85);

        const code = OauthTools.generateAsciiRandom(codeSize);

        OauthTools.validateCodeVerifier(code);
        return code;
    },

    generateRandomState: () => {
        return OauthTools.generateRandomBase64(32);
    },

    generateRandomNonce: () => {
        return OauthTools.generateRandomBase64(32);
    },

    generateRandomBase64: (length: number) => {
        const bytes = OauthTools.generateRandomBytes(length);
        return OauthTools.encodeBase64Url(bytes);
    },

    generateAsciiRandom: (length: number) => {
        let result = '';
        // Unrreserved Alphaa  %x41-5A / %x61-7A
        // Unreserved Digit  %x30-39
        // "-" / "." / "_" / "~
        const unreservedAlpha = Array.from({ length: 26 }, (_, i) => String.fromCharCode(0x41 + i)).join('') + Array.from({ length: 26 }, (_, i) => String.fromCharCode(0x61 + i)).join('');
        const unreservedDigit = Array.from({ length: 10 }, (_, i) => String.fromCharCode(0x30 + i)).join('');
        const unreserved = unreservedAlpha + unreservedDigit + '-._~';

        for (let i = 0; i < length; i++) {
            const randomBytes = forge.random.getBytesSync(4)
            const int = Math.abs(forge.util.createBuffer(randomBytes).getInt32());
            result += unreserved.charAt(int % unreserved.length);
        }
        return result;
    },

    calculatePKCECodeChallenge: (code_verifier: string) => {
        const md = forge.md.sha256.create();
        md.update(code_verifier);
        const code_challenge = md.digest()
        
        return OauthTools.encodeBase64Url(code_challenge);

    },

    encodeBase64Url: (str: forge.util.ByteStringBuffer): string => {
        let base64 = forge.util.encode64(str.getBytes());
        return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
    },

    generateRandomBytes: (length: number): forge.util.ByteStringBuffer => {
        const bytes = forge.random.getBytesSync(length);
        return forge.util.createBuffer(bytes);
    },

    validateCodeVerifier: (code_verifier: string) => {
        if (OauthTools.emptyString(code_verifier)) {
            throw new Error("Code verifier must not be empty");
        }

        if (!OauthTools.isOnlyAscii(code_verifier)) {
            throw new Error("Code verifier must contain only ASCII characters (between 0x00 and 0x7F)");
        }

        if (!OauthTools.hasLengthBetween(code_verifier, 43, 128)) {
            throw new Error("Code verifier must have a length between 43 and 128 characters");
        }

        return true;
    },

    hasLengthBetween: (str: string, min: number, max: number) => {
        return str.length >= min && str.length <= max;
    },

    hasMinimumLength: (str: string, length: number) => {
        return str.length >= length;
    },

    isOnlyAscii: (str: string) => {
        return /^[\x00-\x7F]*$/.test(str);
    },

    emptyString: (str: string) => {
        return typeof str === 'string' && str.length === 0;
    },

}